// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Importing type from server outside rootDir - legacy code, we need to refactor this issue caused by accessing a server file in the client
import type { clientConfig } from "../../server/src/clientConfig";

export const compiledClientConfig = {
  basePrefix: "",
  spog: false,
  // @ts-expect-error Legacy
  ...(window.clientEnv as typeof clientConfig),
};
